import React from "react";
import AdminModulePage from "../../../components/Admin/ModulePage/AdminModulePage";

const Accounts = () => {
    return <AdminModulePage moduleKey="accounts" />;
};

export default Accounts;
